var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialTrainersCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3379 1.14111H15.6759C16.7367 1.14111 17.7542 1.56254 18.5043 2.31269C19.2544 3.06283 19.6759 4.08025 19.6759 5.14111V11.8031C19.6759 12.6792 19.5031 13.5466 19.1674 14.3558C18.8318 15.165 18.3398 15.9 17.7197 16.5188C17.0996 17.1376 16.3635 17.6281 15.5536 17.962C14.7438 18.296 13.876 18.467 12.9999 18.4652C11.233 18.4652 9.53852 17.7633 8.28915 16.5139C7.03978 15.2645 6.33789 13.57 6.33789 11.8031V5.14111C6.33789 4.08025 6.75932 3.06283 7.50946 2.31269C8.25961 1.56254 9.27702 1.14111 10.3379 1.14111Z",
    fill: "url(#paint0_linear_149_3293)",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33789 6.47913H19.6759C19.6759 7.00559 19.5719 7.52687 19.3701 8.01309C19.1682 8.4993 18.8723 8.94088 18.4994 9.31249C18.1265 9.68411 17.6839 9.97846 17.1969 10.1787C16.71 10.3789 16.1884 10.481 15.6619 10.4791H10.3379C9.27702 10.4791 8.25961 10.0577 7.50946 9.30755C6.75932 8.55741 6.33789 7.53999 6.33789 6.47913Z",
    fill: "url(#paint1_linear_149_3293)",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.8032V30.4095C1.0184 27.2377 2.29035 24.2019 4.5384 21.9642C6.78645 19.7266 9.82816 18.4688 13 18.4652C16.1815 18.4689 19.2316 19.7344 21.4812 21.984C23.7308 24.2336 24.9963 27.2837 25 30.4652V31.8589",
    fill: "url(#paint2_linear_149_3293)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.8032V30.4095C1.0184 27.2377 2.29035 24.2019 4.5384 21.9642C6.78645 19.7266 9.82816 18.4688 13 18.4652C16.1815 18.4689 19.2316 19.7344 21.4812 21.984C23.7308 24.2336 24.9963 27.2837 25 30.4652V31.8589",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 29.1412C13.739 29.1412 14.3381 28.5421 14.3381 27.8032C14.3381 27.0642 13.739 26.4652 13.0001 26.4652C12.2611 26.4652 11.6621 27.0642 11.6621 27.8032C11.6621 28.5421 12.2611 29.1412 13.0001 29.1412Z",
    fill: "url(#paint3_linear_149_3293)",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 31.8031V27.8031",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33789 18.4791L12.9999 26.4652L19.6619 18.4791",
    fill: "url(#paint4_linear_149_3293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33789 18.4791L12.9999 26.4652L19.6619 18.4791",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_3293",
    x1: 6.33789,
    y1: 2.37854,
    x2: 19.9496,
    y2: 2.65158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_3293",
    x1: 6.33789,
    y1: 6.76484,
    x2: 19.8531,
    y2: 7.93901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_149_3293",
    x1: 1,
    y1: 19.4219,
    x2: 25.4492,
    y2: 20.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_149_3293",
    x1: 11.6621,
    y1: 26.6563,
    x2: 14.3922,
    y2: 26.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_149_3293",
    x1: 6.33789,
    y1: 19.0496,
    x2: 19.9152,
    y2: 19.6398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialTrainersCount);
export default __webpack_public_path__ + "static/media/special_trainers_count.3454dc2808133d1fc63666dd0fe65842.svg";
export { ForwardRef as ReactComponent };